import { validator } from "@/utils/validator";

export const renewVisaApplicationResultInformationSchema = validator.object().shape({
  applicationResultInformation: validator
    .array()
    .of(
      validator.object().shape({
        renewVisaDocumentStepId: validator.number().required(),
        renewVisaDocumentId: validator.number().required(),
        applicationResult: validator.string().isSelection().trim().emptyToNull().label("申請結果").required(),
        immigrationMailTrackingNumber: validator.string().trim().emptyToNull().label("入管送付郵便の追跡番号").notRequired(),
        replyEnvelopeTrackingNumber: validator.string().trim().emptyToNull().label("返信用封筒の追跡番号").notRequired(),
      }),
    )
    .required(),
});
